/**
 * Запрос токена доступа по коду авторизации МСИ.
 */
export class TokenRequest {
    /**
     * Код авторизации (authorization code)
     */
    code: string;

    /**
     * Состояние
     */
    state: string;

    constructor(code: string, state: string) {
        this.code = code;
        this.state = state;
    }
}
